import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M16.8072 16.801C15.2241 16.801 15.2241 14.4013 16.8072 14.4013C18.0785 14.4013 18.99 14.4853 20.0814 13.7414C22.9837 11.7616 21.4726 7.08224 17.8866 7.21422C16.2915 -0.716723 3.8185 1.97093 6.3011 10.1298C3.79451 8.13811 0.844171 12.0016 3.36276 13.8733C5.16175 15.2172 8.41191 13.3814 8.41191 15.6011C8.41191 17.1129 6.69689 16.801 5.05381 16.801C1.04806 16.801 -1.41057 12.5295 0.880141 9.26596C1.97153 7.70617 3.68658 7.32222 3.68658 7.32222C4.47813 1.19104 11.4822 -2.04855 16.6633 1.41899C18.894 2.90679 19.7336 5.09052 19.7336 5.09052C25.8981 6.96227 25.7662 16.801 16.8072 16.801ZM16.8312 13.2014H16.8192C17.2869 12.0016 17.2869 11.7256 16.8072 11.2577L13.7009 8.03012C12.7655 7.09425 11.2423 7.03425 10.3068 7.97013L7.2006 11.0417C6.73286 11.5097 6.00127 12.2536 7.2006 12.7215V12.7095C7.2006 13.1774 8.42391 13.1774 8.89165 12.7095L9.76715 11.8336C10.1389 11.4497 10.7866 11.7256 10.7866 12.2536V22.8002C10.7866 23.4601 11.4222 24 12.0819 24H12.1298C12.7895 24 13.1852 23.4601 13.1852 22.8002V12.2536C13.1852 11.7136 13.8329 11.4497 14.2047 11.8336L15.0802 12.9615C15.5839 13.4174 16.3634 13.2014 16.8312 13.2014Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
